import {Component, EventEmitter, Input, IterableDiffers, OnInit, Output} from '@angular/core';
import {FilterItem} from '../../../../../../../domain/assistance/model/filterItem';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
             selector: 'app-filter-selection',
             templateUrl: './home-assistance-list-filter-form.component.html'
           })
export class HomeAssistanceListFilterFormComponent implements OnInit {

  @Input() label: string | undefined;
  @Input() source: Array<FilterItem> | undefined;
  @Input() dataToggle: string | undefined;
  @Output() submitForm: EventEmitter<any> = new EventEmitter();
  items: Array<FilterItem> = [];
  differ: any;
  allToggled: boolean | undefined;

  @Input() selectionForm: FormGroup;

  constructor(differs: IterableDiffers, private fb: FormBuilder) {
    this.differ = differs.find([]).create(undefined);
    this.selectionForm = this.fb.group({});
  }

  ngOnInit(): void {
    this.items = [];
    this.source?.forEach(item => {
      this.items?.push(Object.assign({}, item));
    });
    this.allToggled = this.items.every(item => item.toggle);
  }


  onClickOnCancel(): void {
    let i = 0;
    if (this.source) {
      for (const item of this.source) {
        this.items[i].toggle = item.toggle;
        i++;
      }
      this.allToggled = this.items?.every(it => it.toggle);
    }
  }

  onClickOnSubmit(): void {
    if (this.source) {
      let i = 0;
      for (const item of this.source) {
        item.toggle = this.items[i].toggle;
        i++;
      }
      this.submitForm.emit();
      this.allToggled = this.items?.every(it => it.toggle);
    }
  }

  onClickOnToggleAll(): void {
    if (this.items?.every(item => item.toggle)) {
      this.items.forEach(item => item.toggle = false);
      this.allToggled = false;
    } else {
      this.items?.forEach(item => item.toggle = true);
      this.allToggled = true;
    }
  }

  onClickOnRefreshToggleAll(item: FilterItem): void {
    item.toggle = !item.toggle;
    this.allToggled = this.items?.every(it => it.toggle);
  }
}
